"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClusteredPickupPointsQuery = void 0;
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _maps = require("../constants/maps");
var _utils = require("../utils");
const useClusteredPickupPointsQuery = isActive => {
  const customInstance = (0, _globalApiClientReact.useApiClient)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const headers = (0, _utils.getHeaders)({
    currentLanguage: language,
    tenant
  });
  const sessionId = (0, _shoppingContext.useSessionId)();
  return (0, _react.useCallback)(async params => {
    if (!isActive) {
      return [];
    }
    const response = await (0, _globalApiClientReact.getShoppingSessionClusteredPickupPoints)(customInstance, sessionId, {
      ...params,
      searchTerm: !params.searchTerm ? undefined : params.searchTerm,
      zoom: params.zoom !== undefined ? Math.ceil(_maps.MAP_MAX_ZOOM - params.zoom) : undefined
    }, headers);
    return response.data.collection.map(({
      pickupPoint,
      coordinates,
      clusterSize,
      ...item
    }) => {
      if (!coordinates) {
        return undefined;
      }
      const {
        latitude,
        longitude
      } = coordinates;
      return {
        ...item,
        pickupPoint,
        clusterSize,
        coordinates,
        displayedClusterSize: Number(clusterSize) > _maps.CLUSTER_SIZE_DISPLAY_LIMIT ? `${_maps.CLUSTER_SIZE_DISPLAY_LIMIT}+` : String(clusterSize ?? ''),
        key: `${pickupPoint ? 'pickup-point' : 'cluster'}-marker-${latitude}-${longitude}-${pickupPoint?.deliveryChannelId ?? clusterSize}`
      };
    }).filter(item => item !== undefined);
  }, [customInstance, headers, isActive, sessionId]);
};
exports.useClusteredPickupPointsQuery = useClusteredPickupPointsQuery;